const SET_ARCHIVE_REQUEST = (state, payload) => {
  state.archiveRequest.period = payload.period;
};

export default SET_ARCHIVE_REQUEST;
